/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { h } from 'preact'

export default function AspectImage({
	className,
	children,
	onClick,
	loading,
	alt,
	title,
	objectFit,
	src,
	dataSrc,
	aspectRatio = {
		x: 16,
		y: 9,
	},
}) {
	const ratio = aspectRatio.y / aspectRatio.x
	const paddingTop = `${ratio * 100}%`

	return (
		<figure
			className="aspect-img --relative"
			onClick={onClick}
			style={{
				paddingTop,
				width: '100%',
				position: 'relative',
			}}
		>
			<img
				className={className}
				src={src}
				data-src={dataSrc}
				loading={loading}
				alt={alt}
				style={{
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
					objectFit,
				}}
			/>
			{children && children}
		</figure>
	)
}
